import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format } from 'date-fns';

export const SECONDS_PER_DAY = 86_400;

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(
  amount: number,
  options?: Intl.NumberFormatOptions
) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    ...options,
  }).format(amount);
}

export function formatUsdValue(value: number | null) {
  if (value === null) {
    return '--';
  }
  return formatCurrency(value, {
    minimumFractionDigits: 2,
  });
}

export function formatAddress(address: string) {
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}

/**
 * Format a Date object to a human-readable string
 * @param date - The Date object to format
 * @param formatString - The date-fns format string (default: 'MMM d, yyyy')
 * @returns Formatted date string or 'Invalid date' on error
 */
export function formatDate(
  date: Date,
  formatString: string = 'MMM d, yyyy'
): string {
  try {
    return format(date, formatString);
  } catch {
    return 'Invalid date';
  }
}
